module.exports = __webpack_public_path__ + "static/img/rank_38.0e93285.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_38.png
// module id = vsnj
// module chunks = 1